/**
 * SKE-5310. A System User login only lists what sits in the business portfolio
 * the person picked. A list it produced carries this quiet way to the
 * User-token login, for the Page or Instagram account that sits in no
 * portfolio. Renders nothing unless the list came from a System User login.
 */
import {
  isConnectionHandleSession,
  type FacebookConnectSession,
} from "../../../../api/social-account-connect/facebook/authorise-facebook";
import { canFallBackToUserToken } from "../../../../api/social-account-connect/facebook/fb-sdk-utils";

interface ConnectAnotherWayLinkProps {
  session: FacebookConnectSession | undefined;
  disabled?: boolean;
  onClick(): void;
}

export function ConnectAnotherWayLink({
  session,
  disabled,
  onClick,
}: ConnectAnotherWayLinkProps) {
  if (
    !session ||
    !isConnectionHandleSession(session) ||
    !canFallBackToUserToken()
  ) {
    return null;
  }
  return (
    <p className="mt-4 mb-0 font-inter text-sm text-neutral-600">
      Missing a Page or Instagram account?{" "}
      <button
        type="button"
        className="text-blue-500 underline-offset-4 hover:text-blue-600 hover:underline disabled:text-neutral-400 disabled:no-underline"
        disabled={disabled}
        onClick={onClick}
        data-testid="connect-another-way-link"
      >
        Connect another way
      </button>
    </p>
  );
}
